import React, { useState } from 'react';
import './PremiosComponent.css';
import PremiosCarruselComponent from '../Galeria/PremiosCarruselComponent';
import PremiosConTexto from '../Galeria/PremiosConTexto';

export const PremiosComponent = (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const yearsPerPage = 10;

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    const calculateYearRange = (buttonIndex) => {
        const startIndex = (buttonIndex - 1) * yearsPerPage;
        const endIndex = startIndex + yearsPerPage - 1;
        const startYear = props.Data[startIndex].year;
        const endYear = props.Data[Math.min(endIndex, props.Data.length - 1)].year;
        return { startYear, endYear };
    };

    const totalPages = Math.ceil(props.Data.length / yearsPerPage);

    const OPTIONS = { loop: true };
    return (
        <>
            <div className='paginado'>
                {[...Array(totalPages).keys()].map((pageIndex) => {
                    const buttonIndex = pageIndex + 1;
                    const { startYear, endYear } = calculateYearRange(buttonIndex);
                    const buttonClass = currentPage === buttonIndex ? 'selected' : '';
                    return (
                        <button key={buttonIndex} onClick={() => handlePageChange(buttonIndex)} className={buttonClass}>
                            {startYear} - {endYear}
                        </button>
                    );
                })}
            </div>

            <div className='premio'>
                {props.Data.slice((currentPage - 1) * yearsPerPage, currentPage * yearsPerPage).map((yearData, index) => (
                    <div key={index} className='contenedor-premios'>
                        <h1>{yearData.year}</h1>
                        <hr />
                        <div className='content-premios'>
                            <PremiosCarruselComponent yearData={yearData} options={OPTIONS} I18n={props.I18n} />
                            <PremiosConTexto yearData={yearData} I18n={props.I18n}/>
                        </div>
                        <hr className='hr-premios' />
                    </div>
                ))}
            </div>
        </>
    );
};